import { OFFER_FRAGMENT } from 'core/fragments/offer';
import gql from 'graphql-tag';

export const REQUEST_QUOTE = gql`
  query (
    $address: String!
    $city: String!
    $state: String!
    $zip: String!
    $unit: String
    $isApartment: Boolean
    $fname: String!
    $lname: String!
    $email: AWSEmail
    $phone: String
    $additionalPhoneNumbers: [AdditionalPhoneNumberInput]
    $leadSource: String
    $rep: String
    $affinity: String
    $dateOfBirth: AWSDate
    $priorAddress: AddressDetailsInput
    $currentAutoCarrier: String
    $currentAutoLimitBIPD: String
    $continuousAutoCoverageYears: Int
    $driversLicenseState: String
    $driversLicenseNumber: String
    $insuranceInPast31Days: Boolean
    $fromStaff: Boolean
    $VIN: String
    $home: HomeDetailsInput
    $condo: CondoDetailsInput
    $connectedHome: ConnectedHomeDetailsInput
    $global: GlobalDetailsInput
    $policyType: String
    $overrides: OverridesInput
    $optIntoMarketingCampaigns: Boolean
    $farmLocations: [LocationDetailInput]
  ) {
    offer: requestQuote(
      userInput: {
        address: $address
        city: $city
        state: $state
        zip: $zip
        unit: $unit
        isApartment: $isApartment
        fname: $fname
        lname: $lname
        email: $email
        phone: $phone
        additionalPhoneNumbers: $additionalPhoneNumbers
        leadSource: $leadSource
        rep: $rep
        affinity: $affinity
        priorAddress: $priorAddress
        dateOfBirth: $dateOfBirth
        currentAutoCarrier: $currentAutoCarrier
        currentAutoLimitBIPD: $currentAutoLimitBIPD
        insuranceInPast31Days: $insuranceInPast31Days
        continuousAutoCoverageYears: $continuousAutoCoverageYears
        driversLicenseState: $driversLicenseState
        driversLicenseNumber: $driversLicenseNumber
        fromStaff: $fromStaff
        VIN: $VIN
        home: $home
        condo: $condo
        connectedHome: $connectedHome
        global: $global
        policyType: $policyType
        overrides: $overrides
        optIntoMarketingCampaigns: $optIntoMarketingCampaigns
        farmLocations: $farmLocations
      }
    ) {
      ...OfferFragment
    }
  }
  ${OFFER_FRAGMENT}
`;

export const REQUEST_BRANCH_PLUS_QUOTE = gql`
  query (
    $address: String!
    $city: String!
    $state: String!
    $zip: String!
    $unit: String
    $isApartment: Boolean
    $fname: String!
    $lname: String!
    $email: AWSEmail
    $phone: String
    $additionalPhoneNumbers: [AdditionalPhoneNumberInput]
    $leadSource: String
    $rep: String
    $affinity: String
    $dateOfBirth: AWSDate
    $priorAddress: AddressDetailsInput
    $currentAutoCarrier: String
    $currentAutoLimitBIPD: String
    $continuousAutoCoverageYears: Int
    $driversLicenseState: String
    $driversLicenseNumber: String
    $insuranceInPast31Days: Boolean
    $fromStaff: Boolean
    $VIN: String
    $home: HomeDetailsInput
    $condo: CondoDetailsInput
    $connectedHome: ConnectedHomeDetailsInput
    $global: GlobalDetailsInput
    $policyType: String
    $overrides: OverridesInput
    $optIntoMarketingCampaigns: Boolean
  ) {
    BranchPlusOfferResponse: asyncGenerateBranchPlusOffers(
      userInput: {
        address: $address
        city: $city
        state: $state
        zip: $zip
        unit: $unit
        isApartment: $isApartment
        fname: $fname
        lname: $lname
        email: $email
        phone: $phone
        additionalPhoneNumbers: $additionalPhoneNumbers
        leadSource: $leadSource
        rep: $rep
        affinity: $affinity
        priorAddress: $priorAddress
        dateOfBirth: $dateOfBirth
        currentAutoCarrier: $currentAutoCarrier
        currentAutoLimitBIPD: $currentAutoLimitBIPD
        insuranceInPast31Days: $insuranceInPast31Days
        continuousAutoCoverageYears: $continuousAutoCoverageYears
        driversLicenseState: $driversLicenseState
        driversLicenseNumber: $driversLicenseNumber
        fromStaff: $fromStaff
        VIN: $VIN
        home: $home
        condo: $condo
        connectedHome: $connectedHome
        global: $global
        policyType: $policyType
        overrides: $overrides
        optIntoMarketingCampaigns: $optIntoMarketingCampaigns
      }
    ) {
      taskId
    }
  }
`;

export const SEND_CLUSTER_LINK = gql`
  mutation ($offerId: ID!, $email: String!, $revisedQuoteDetails: QuoteDetailsInput!, $agent: AgentInput) {
    cluster: sendClusterLink(
      offerId: $offerId
      email: $email
      revisedQuoteDetails: $revisedQuoteDetails
      agent: $agent
    ) {
      id
    }
  }
`;

export const REQUEST_QUINSTREET_QUOTE = gql`
  query ($quoteDetails: QuinstreetQuoteDetailsInput!, $policyType: String!, $policyId: ID, $offerId: ID) {
    quinstreetOffers: requestQuinstreetQuote(
      quoteDetails: $quoteDetails
      policyType: $policyType
      policyId: $policyId
      offerId: $offerId
    ) {
      premium
      bridgeUrl
      monthly
      status
      carrierName
      carrierId
      message
      sessionId
    }
  }
`;

export const ASYNC_GENERATE_BRANCH_PLUS_OFFERS_FROM_OFFER = gql`
  query (
    $quoteDetails: QuinstreetQuoteDetailsInput!
    $policyType: String!
    $policyId: ID
    $offerId: ID
    $webUserId: ID
  ) {
    asyncGenerateBranchPlusOffersFromOffer(
      quoteDetails: $quoteDetails
      policyType: $policyType
      policyId: $policyId
      offerId: $offerId
      webUserId: $webUserId
    ) {
      taskId
    }
  }
`;

export const ON_BRANCH_PLUS_OFFER_GENERATED = gql`
  subscription OnBranchPlusOfferGenerated($taskId: ID!) {
    onBranchPlusOfferGenerated(taskId: $taskId) {
      taskId
      data
      error
    }
  }
`;
